import { closest, Slice, Fragment, ReplaceAroundStep, } from '@tencent/exeditor3-core';
import { splitListItem, liftListItem } from 'prosemirror-schema-list';
import { toggleList } from './toggle.js';
import { createHTMLPreprocessor } from './transforms.js';
import { NAME, GROUP_NAME, LIST_GROUP } from './conf.js';
import { isListNode, closestList, closestListItem, sinkListItem, } from './listMethods.js';
export * from './switchListStyleType.js';
export { NAME, GROUP_NAME, LIST_GROUP, toggleList, closestList, isListNode };
const defaultPluginOptions = {
    disableMSOListResolve: false,
};
export class ListItemPlugin {
    constructor(opt = {}) {
        this.name = NAME;
        this.spec = {
            defining: true,
            type: 'node',
            group: GROUP_NAME,
            childrenType(specs) {
                const codeBlockNames = specs
                    .filter((spec) => (spec.type === 'node' || spec.type === 'block') && spec.code)
                    .map((spec) => spec.name);
                return `(${['paragraph', ...codeBlockNames].join('|')}) block*`;
            },
            matchSelector: 'li',
            toDOM: 'li',
        };
        this.splitListItem = () => this.executeWithType(splitListItem);
        this.sinkListItem = () => this.executeWithType(sinkListItem);
        this.liftListItem = () => this.executeWithType(liftListItem);
        this.executeWithType = (command) => {
            const type = this.getNodeType();
            return this.editor.execute(command(type));
        };
        this.getNodeType = () => this.editor.schemaInstance.nodes[this.name];
        this.splitListItemAtItsEnd = (state, dispatch) => {
            const { $from, $to } = state.selection;
            if (!$from.sameParent($to) || $to.nodeAfter) {
                return false;
            }
            const grandParent = $from.node(-1);
            if ((grandParent === null || grandParent === void 0 ? void 0 : grandParent.type) !== this.getNodeType()) {
                return false;
            }
            if (!$from.nodeBefore) {
                return this.liftListItem();
            }
            const tr = state.tr.delete($from.pos, $to.pos).split($from.pos, 2);
            dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
            return true;
        };
        // 【改进毗邻 list 的非首位 listItem tab 行为】
        // http://tapd.oa.com/exeditor_next/prong/stories/view/1020454153871864007
        this.sinkFirstListItemAfterOtherList = (state, dispatch) => {
            const { empty, $from } = state.selection;
            if (!empty) {
                return false;
            }
            const listItem = closestListItem($from);
            const { node: list, pos: listPos } = closest($from, isListNode);
            if (!listItem || !list || list.firstChild !== listItem) {
                return false;
            }
            const anotherList = state.doc.resolve(listPos).nodeBefore;
            if (!anotherList || !isListNode(anotherList)) {
                return false;
            }
            if (dispatch) {
                const nodeType = this.getNodeType();
                const { tr } = state;
                // 把 list 放到 anotherList 的最后一个 listItem 中
                tr.step(new ReplaceAroundStep(listPos - 2, listPos + list.nodeSize, listPos, listPos + list.nodeSize, new Slice(Fragment.from(anotherList.copy(Fragment.from(nodeType.create()))), 2, 0), 0));
                dispatch(tr);
            }
            return true;
        };
        this.handleBackspaceInList = (state, dispatch, view) => {
            const { empty, $from } = state.selection;
            if (!empty) {
                return false;
            }
            if (view && !view.endOfTextblock('backward')) {
                return false;
            }
            const listItem = closestListItem($from);
            const list = closestList($from);
            if (!listItem || !list) {
                return false;
            }
            // first item in list
            if (list.firstChild === listItem) {
                // first paragraph in list-item
                if (listItem.firstChild === $from.node()) {
                    const nodeType = this.getNodeType();
                    return liftListItem(nodeType)(state, dispatch);
                }
                return false;
            }
            return false;
        };
        this.handleBackspaceAfterList = (state) => {
            const { empty, $from } = state.selection;
            if (!empty || $from.parentOffset || !$from.pos) {
                return false;
            }
            const before = $from.before();
            const { nodeBefore } = state.doc.resolve(before);
            if (!nodeBefore || !isListNode(nodeBefore)) {
                return false;
            }
            let lastPosInNodeBefore = before;
            nodeBefore.descendants((node, pos) => {
                lastPosInNodeBefore = before - nodeBefore.nodeSize + pos + node.nodeSize;
            });
            this.editor
                .delete(lastPosInNodeBefore + 1, $from.pos)
                .selection(lastPosInNodeBefore + 1);
            return true;
        };
        this.opt = {
            ...defaultPluginOptions,
            ...opt,
        };
    }
    capabilities() {
        return {
            commands: {
                splitListItem: this.splitListItem,
                sinkListItem: this.sinkListItem,
                liftListItem: this.liftListItem,
            },
            shortcuts: {
                Enter: [this.splitListItemAtItsEnd, this.splitListItem],
                'Mod-Enter': [this.splitListItemAtItsEnd, this.splitListItem],
                Tab: [this.sinkListItem, this.sinkFirstListItemAfterOtherList],
                'Shift-Tab': this.liftListItem,
                Backspace: [this.handleBackspaceInList, this.handleBackspaceAfterList],
            },
            transformHTML: createHTMLPreprocessor(this.opt),
        };
    }
    initEditor(editor) {
        this.editor = editor;
    }
}
//# sourceMappingURL=index.js.map